import React from "react";
import styled, { withTheme } from "styled-components";
import { FlexBase } from "../Cards";
import PropTypes from "prop-types";
import ResponsiveImage from "../ResponsiveImage";

const StyledFlexBase = styled(FlexBase)`
    background: transparent;
    align-items: center;
    justify-content: center;
    height: 150px;
    margin-top: 2em;
`;

const StyledImage = styled(ResponsiveImage)`
    border-radius: ${props => props.theme.defaults.borderRadius};
`;

const TallImageBanner = ({ schema: { background, src, alt }, theme: { colours = {} }, className }) => {
    const backgroundColour = background ? background : colours.flat.white.hex;

    return (
        <StyledFlexBase className={`thank-you-banner-${className}`} background={backgroundColour}>
            <StyledImage src={src} alt={alt} />
        </StyledFlexBase>
    );
};

TallImageBanner.propTypes = {
    className: PropTypes.string,
    theme: PropTypes.object.isRequired,
    schema: PropTypes.object.isRequired
};

export default withTheme(TallImageBanner);
